import { Box, Avatar, Text, VStack, HStack, Badge } from '@chakra-ui/react'
import { ParentProfileData } from './type'

type ParentProfileProps = {
    profile: ParentProfileData['findMyProfileAsParent']
}

export const ParentProfileCard = ({ profile }: ParentProfileProps) => {
    return (
        <Box
            bg={'gray.50'}
            color={'brand'}
            w="full"
            maxW="sm"
            height={'fit-content'}
            p={4}
            borderWidth={1}
            borderRadius="md"
            boxShadow="md"
        >
            <HStack spacing={4} align="center">
                <Avatar size="xl" name={profile.firstName} src={profile.picture || ''} />
                <VStack spacing={1} textAlign="center">
                    <Text fontSize="xl" fontWeight="bold">
                        {profile.firstName} {profile.lastName}
                    </Text>
                    <Badge colorScheme="brand">{profile.relationship}</Badge>
                </VStack>
            </HStack>
            <HStack spacing={4} align="baseline">
                {profile.children.length > 0 && (
                    <Box mt={4}>
                        <Text fontWeight="bold">Children:</Text>
                        <VStack align="start" spacing={1}>
                            {profile.children.map((child) => (
                                <Text key={child._id} fontSize="sm">
                                    - {child.firstName} {child.lastName}
                                </Text>
                            ))}
                        </VStack>
                    </Box>
                )}

                {profile.branch && (
                    <Box mt={4}>
                        <Text fontWeight="bold">Branch:</Text>
                        <Text fontSize="sm">{profile.branch.name}</Text>
                    </Box>
                )}
            </HStack>

            {profile.coParent ? (
                <Box mt={4} bg="green.100" borderRadius="md" p={2}>
                    <Text fontWeight="bold">Co-Parent:</Text>
                    <HStack spacing={3} align="center">
                        <Avatar
                            size="sm"
                            name={profile.coParent.firstName}
                            src={profile.coParent.picture || ''}
                        />
                        <VStack align="start" spacing={0}>
                            <Text fontSize="sm">
                                {profile.coParent.firstName} {profile.coParent.lastName}
                            </Text>
                            <Text fontSize="xs" color="gray.500">
                                {profile.coParent.email}
                            </Text>
                            <Badge colorScheme="brand">
                                {profile.coParent.relationship}
                            </Badge>
                        </VStack>
                    </HStack>
                </Box>
            ) : (
                <Box mt={4} bg="red.100" borderRadius="md" p={2}>
                    <Text fontSize="md">No co-parent linked to you!</Text>
                </Box>
            )}
        </Box>
    )
}
